export const BOOKING_TYPE = {
  EVERY: 'every',
  ONCE: 'once',
};

export const ENUMS = {
  INCREMENT: 'increment',
  DECREMENT: 'decrement',
  NUMBER_OF_BOOKING: 'numberOfBookings',
  PLUS: 'plus',
  MINUS: 'minus',
  DEFAULT_DATE_FORMAT: 'MMM D, YYYY',
  DEFAULT_MONTH_DATE_FORMAT: 'MMM D',
};
